module.exports = __webpack_public_path__ + "img/28_big.52b4bfad.png";